export const isNotEmptyString = (s: string | undefined): boolean => {
	return !!s && s.length > 0;
};

export const isEmptyString = (s: string | undefined): boolean => {
	return !s || s.length === 0;
};

// see https://github.com/orgs/react-hook-form/discussions/8020
export function withExceptionCapturing<S, T extends unknown[]>(fn: (...rest: T) => Promise<S>) {
	return (...args: T) => {
		fn(...args).catch((error: unknown) => {
			console.log("Unexpected error in promise", error);
		});
	};
}

export function requireValue<T>(value: T | null | undefined): T {
	if (value === null || value === undefined) {
		throw Error("Unexpected null or undefined value");
	}

	return value;
}

export type Language = "fi" | "en";

type Enumerate<N extends number, Acc extends number[] = []> = Acc["length"] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc["length"]]>;

/** Type for a integer range starting from TStart and ending with TEnd */
export type Range<TStart extends number, TEnd extends number> = Exclude<Enumerate<TEnd>, Enumerate<TStart>> | TEnd;

/**
 * Creates an increasing sequence of integers starting from start and ending with end.
 * 
 * The return value is typed as an array of integers between start and end (inclusive) with unspecified order.
 * Should be used for relatively small numbers (max 998) due to the limitation in the recursive type definition:
 * https://github.com/microsoft/TypeScript/pull/45711
 * 
 * @param {number} start - lower bound for the sequence (inclusive)
 * @param {number} end - upper bound for the sequence (inclusive)
 */
export function numberSequence<TStart extends number, TEnd extends number>(start: TStart, end: TEnd): Range<TStart, TEnd>[] {
	return Array.from({length: end}, (_, i) => start + i) as Range<TStart, TEnd>[];
}
